import { render, staticRenderFns } from "./VideoconsultationLinkDivider.vue?vue&type=template&id=2ed9bb56"
import script from "./VideoconsultationLinkDivider.vue?vue&type=script&lang=js"
export * from "./VideoconsultationLinkDivider.vue?vue&type=script&lang=js"
import style0 from "./VideoconsultationLinkDivider.vue?vue&type=style&index=0&id=2ed9bb56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports